import { render, staticRenderFns } from "./formatos-revision.vue?vue&type=template&id=24a51085&scoped=true"
import script from "./formatos-revision.vue?vue&type=script&lang=js"
export * from "./formatos-revision.vue?vue&type=script&lang=js"
import style0 from "./formatos-revision.vue?vue&type=style&index=0&id=24a51085&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a51085",
  null
  
)

export default component.exports